import { render, staticRenderFns } from "./transferisimlistesi.vue?vue&type=template&id=56fd048c&scoped=true&"
import script from "./transferisimlistesi.vue?vue&type=script&lang=js&"
export * from "./transferisimlistesi.vue?vue&type=script&lang=js&"
import style0 from "./transferisimlistesi.vue?vue&type=style&index=0&id=56fd048c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd048c",
  null
  
)

export default component.exports